import axios from "axios";
let csrfToken = null;

// Domains permitted for API calls, guards against SSRF via a tampered/misconfigured base URL.
const ALLOWED_API_HOSTNAME_PATTERN =
  /^(localhost|([a-z0-9-]+\.)?autocheck\.com)$/i;

const getValidatedApiBaseUrl = () => {
  const rawBaseUrl = process.env.REACT_APP_API_BASE_URL;
  try {
    const { protocol, hostname } = new URL(rawBaseUrl);
    const isAllowedProtocol =
      protocol === "https:" ||
      (protocol === "http:" && hostname === "localhost");
    if (isAllowedProtocol && ALLOWED_API_HOSTNAME_PATTERN.test(hostname)) {
      return rawBaseUrl;
    }
  } catch {
    // fall through to error below
  }
  throw new Error(
    "Invalid REACT_APP_API_BASE_URL: host is not in the allowed list",
  );
};

export const API_BASE_URL = getValidatedApiBaseUrl();

export const getCsrfToken = async () => {
  try {
    // Call consumer services for CSRF Token
    const csrfTokenResponse = await axios.get(
      `${API_BASE_URL}/csrf-token/v1/token`,
      {
        withCredentials: true,
      },
    );

    // Pull csrf token from response header and return
    csrfToken = csrfTokenResponse.headers["x-csrf-token"];
    return csrfToken;
  } catch (error) {
    return Promise.reject(new Error("Failed to fetch CSRF token"));
  }
};

export { csrfToken };
